import React from 'react';

export default function ProjectTypeIcon({
  width = 48,
  height = 48,
  fill = '#9F9FA0',
  className,
  ...props
}: React.SVGProps<SVGSVGElement> & {
  width?: number | string;
  height?: number | string;
  fill?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g clipPath="url(#clip0_10015_20119)">
        <path d="M39.2247 9.40527H34.6709V14.152H39.2247V9.40527Z" fill={fill} />
        <path d="M30.1167 9.40527H25.6689V14.152H30.1167V9.40527Z" fill={fill} />
        <path d="M30.1167 18.8427H25.6689V23.5894H30.1167V18.8427Z" fill={fill} />
        <path d="M16.3589 32.916H11.9111V37.6628H16.3589V32.916Z" fill={fill} />
        <path d="M39.2247 18.8971H34.6709V23.5333H39.2247V18.8971Z" fill={fill} />
        <path d="M39.2247 28.28H34.6709V32.9162H39.2247V28.28Z" fill={fill} />
        <path d="M24.638 47.2256H3.24103C1.45429 47.2256 0 45.7097 0 43.8473V31.6184C0 30.4844 0.541821 29.4315 1.44721 28.8048L12.3501 21.2563C13.4309 20.5072 14.8315 20.5028 15.9179 21.2431L26.4106 28.3949C27.3302 29.0216 27.8776 30.0789 27.8776 31.2232V43.8488C27.8776 45.7112 26.4233 47.2271 24.6366 47.2271L24.638 47.2256ZM14.1439 23.6408C14.0647 23.6408 13.9855 23.6644 13.9162 23.713L3.01326 31.2615C2.89867 31.3412 2.82935 31.4754 2.82935 31.6199V43.8488C2.82935 44.0847 3.01468 44.2779 3.24103 44.2779H24.6366C24.863 44.2779 25.0483 44.0847 25.0483 43.8488V31.2232C25.0483 31.0772 24.979 30.943 24.8615 30.8634L14.3675 23.7115C14.2996 23.6644 14.2203 23.6408 14.1425 23.6408H14.1439Z" fill={fill} />
        <path d="M44.2736 46.7126H30.1169V43.7634H44.2736C44.7687 43.7634 45.1705 43.3431 45.1705 42.8285V4.65829C45.1705 4.14217 44.7673 3.72339 44.2736 3.72339H21.278C20.7829 3.72339 20.3811 4.14365 20.3811 4.65829V20.671L17.5518 18.7865V4.65829C17.5518 2.51568 19.2239 0.77417 21.278 0.77417H44.2736C46.3291 0.77417 47.9999 2.51716 47.9999 4.65829V42.8285C47.9999 44.9711 46.3277 46.7126 44.2736 46.7126Z" fill={fill} />
      </g>
      <defs>
        <clipPath id="clip0_10015_20119">
          <rect width="48" height="48" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
